export default {
  label: {
    original: 'Original: ',
    originalNotFound: 'Não encontrado',
    reloadButtonText: 'Recarregar',
    errorMessage: 'Erro ao carregar dados',
  },
};
